import { all } from 'redux-saga/effects';

import newBookingSaga from './new-booking-saga';
import manageBookingSaga from './manage-booking-saga';

export default function* rootSaga() {
  yield all([newBookingSaga(), manageBookingSaga()]);
}
